import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    confirm: 'Confirm',
    title: "Select the wallet's icon",
  },
  fr: {
    confirm: 'Confirmer',
    title: 'Choisissez l’icône du compte',
  },
} as const);

export default locales;
